import { api } from './client';

export interface KBBrief {
  id: string;
  title: string;
  tags: string | null;
  is_public: boolean;
  is_published: boolean;
  updated_at: string;
  snippet: string | null;
}

export interface KBArticle {
  id: string;
  title: string;
  body_md: string;
  tags: string | null;
  is_public: boolean;
  is_published: boolean;
  created_at: string;
  updated_at: string;
  author_name: string | null;
}

export interface KBInput {
  title: string;
  body_md: string;
  tags?: string | null;
  is_public: boolean;
  is_published: boolean;
}

export interface PostToTicketResult {
  ok: boolean;
  message_id: string | null;
  ticket_number: number | null;
  sent_to_tg: boolean;
  sent_to_max: boolean;
  notes: string[];
}

export const kbApi = {
  list: (q?: string) =>
    api.get<KBBrief[]>('/api/v1/kb', { params: { q, limit: 2000 } }).then(r => r.data),
  get: (id: string) =>
    api.get<KBArticle>(`/api/v1/kb/${id}`).then(r => r.data),
  create: (p: KBInput) =>
    api.post<KBArticle>('/api/v1/kb', p).then(r => r.data),
  update: (id: string, p: KBInput) =>
    api.patch<KBArticle>(`/api/v1/kb/${id}`, p).then(r => r.data),
  remove: (id: string) =>
    api.delete(`/api/v1/kb/${id}`),
  postToTicket: (articleId: string, ticketId: string,
                 opts: { also_channels?: boolean; internal?: boolean } = {}) =>
    api.post<PostToTicketResult>(`/api/v1/kb/${articleId}/post-to-ticket`, {
      ticket_id: ticketId,
      also_channels: opts.also_channels ?? true,
      internal: opts.internal ?? false,
    }).then(r => r.data),
};
